import { BackgroundSVG } from '../../icons/SvgIcons';

export function Background() {
  return (
    <div className="absolute inset-0 -z-10 w-full h-full">
      <div className="w-full h-full">
        <BackgroundSVG />
      </div>
    </div>
  );
}
